module.exports = __webpack_public_path__ + "img/floor_f5_01.f3a7f4c5.png";